<template>
  <div>
    <van-nav-bar
      :fixed="fixed"
      :border="false"
      :title="title"
      @click-left="$router.go(-1)"
    >
    <template #left>
        <van-icon v-if="isShowArrow" name="ri ri-arrow-left-s-line" size="0.5rem" color="#fff"  @click-left="$router.go(-1)"/>
    </template>
  </van-nav-bar>
  </div>
</template>

<script>
  export default {
    props:{
      title:{
        type: String,
        default: ''
      },
      isShowArrow:{
        type: Boolean,
        default: false
      },
      fixed:{
        type: Boolean,
        default: false
      }

    },
    data(){
      return{

      }
    },
    methods:{
     
    },
   
  }
</script>

<style lang="less" scoped>
  ::v-deep{
    .van-nav-bar{
      background: #427AF4;
      // background: transparent;
    }
    .van-nav-bar__title{
      // font-size: 17px;
      color: rgba(255,255,255,0.9);
      font-weight: 600;
    }
  }
</style>